// https://teampage.socialbeat.in

// http://localhost:7000

const BASE_ENDPOINT = "https://teampage.socialbeat.in";

// const BASE = '/api'

export const API_ENDPOINT = BASE_ENDPOINT;
